import React from 'react';
import { twMerge } from 'tailwind-merge';

interface DashboardProps {
  className?: string;
  width?: number;
  height?: number;
}

const DashboardIcon = function DashboardIcon({
  className,
  width,
  height,
}: DashboardProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 21 21"
    >
      <g clipPath="url(#clip0_12_3709)">
        <rect className={twMerge(className, 'fill-transparent')} width="6" height="6" rx="1" transform="matrix(1 0 0 -1 14 10)" stroke="#F97171" strokeLinecap="round" />
        <path className={twMerge(className, 'fill-transparent')} d="M10 14H14C14.9428 14 15.4142 14 15.7071 14.2929C16 14.5858 16 15.0572 16 16V18C16 18.9428 16 19.4142 15.7071 19.7071C15.4142 20 14.9428 20 14 20H10V14Z" fill="#F97171" stroke="#FFF4F4" strokeLinecap="round" />
        <path className={twMerge(className, 'fill-transparent')} d="M10 10C10 9.05719 10 8.58579 9.70711 8.29289C9.41421 8 8.94281 8 8 8H6C5.05719 8 4.58579 8 4.29289 8.29289C4 8.58579 4 9.05719 4 10V14H10V10Z" fill="#F97171" stroke="#FFF4F4" strokeLinecap="round" />
        <path className={twMerge(className, 'fill-transparent')} d="M10 20H6C5.05719 20 4.58579 20 4.29289 19.7071C4 19.4142 4 18.9428 4 18V14H10V20Z" fill="#F97171" stroke="#FFF4F4" strokeLinecap="round" />
      </g>
    </svg>
  );
};

DashboardIcon.defaultProps = {
  className: '',
  width: 16,
  height: 16,
};

export default DashboardIcon;
